import { useEffect } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
} from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";

import { User, Settings } from "../../../interfaces";
import UsageDashboard from "../../../components/usage/dashboard";

const Usage: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const intl = useIntl();

  useEffect(() => {
    props.onRequestSettings();
  }, []);

  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/settings"
              text={intl.formatMessage({ id: "common.back" })}
            />
          </IonButtons>
          <IonTitle>
            <FormattedMessage id="usage.title" />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen color="light">
        <div className="view-wrapper">
          <div className="view-pane-title mt-4">
            <FormattedMessage id="usage.subTitle" />
          </div>
          <div className="view-pane">
            <UsageDashboard isMobile={true} />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  onRequestSettings: Function;
  user: User;
  settings: Settings;
}

export default Usage;
